import client from './client'

const apiBasePath = '/api/common/'

export default {
  codeDefList: entryForm => client.get(apiBasePath + 'code-def-list', entryForm),
  groupList: entryForm => client.get(apiBasePath + 'group-list', entryForm),
  groupListEntry: entryForm => client.get(apiBasePath + 'group-list-entry', entryForm),
  serviceList: () => client.get(apiBasePath + 'service-list'),
  companyList: groupSmallId => client.post(apiBasePath + 'company-list', groupSmallId),
  branchList: companyId => client.post(apiBasePath + 'branch-list', companyId),
  labelList: key => client.post(apiBasePath + 'label-list', key),
  messageList: () => client.get(apiBasePath + 'message-list'),
  userServiceList: () => client.get(apiBasePath + 'user-service-list'),
  fromAddressList: () => client.get(apiBasePath + 'from-address-list')
}
